import React from 'react';

import '../css/button.css';

export default function Button(props) {
  return (
    <button
      className={`button ${props.buttonClass} ${
        props.moveButton ? 'move-button' : ''
      }`}
    >
      {props.value}
    </button>
  );
}
